import { createFileRoute } from '@tanstack/react-router'
import { myEduInternSearchSchema } from '@/features/my-edu-interns/filter-my-edu-interns/model/myEduInternSearch'
import { MyEduInternsPage } from '@/pages/internships/ui/MyEduInternsPage'

export const Route = createFileRoute('/my-edu-interns')({
  validateSearch: myEduInternSearchSchema,
  component: MyEduInternsPage,
})
